export const safeNext = () => {
  const n = new URLSearchParams(window.location.search).get("next") || "";
  return n.startsWith("/") && !n.startsWith("//") ? n : "/dashboard";
};

export const withNext = (path) => (window.location.search.includes("next=") ? `${path}${window.location.search}` : path);
